import _jsx from "@babel/runtime/helpers/jsx";
var _span;
import PropTypes from 'prop-types';
import React from 'react';
const OPTIONAL = '(optional)';

/**
 *  FormElementLabel renders a label to a form element, such as Input, Checkbox, etc
 *
 */
function FormElementLabel(_ref) {
  let {
    fakeLabel = false,
    label,
    optional = false,
    layout,
    ...rest
  } = _ref;
  if (!label) {
    return null;
  }
  let optionalLabel = null;
  if (optional && layout !== 'inside') {
    optionalLabel = /*#__PURE__*/_jsx("span", {}, void 0, label, _span || (_span = /*#__PURE__*/_jsx("span", {
      className: "text-size-200 text-normal supporting-label margin-left-1"
    }, void 0, OPTIONAL)));
  } else if (optional) {
    optionalLabel = `${label} ${OPTIONAL}`;
  }
  const LabelNode = fakeLabel ? 'div' : 'label';
  return /*#__PURE__*/React.createElement(LabelNode, Object.assign({
    key: "form-element-label",
    "data-cmp": "form-element-label"
  }, rest), optional ? optionalLabel : label);
}
export default FormElementLabel;